// extracted by mini-css-extract-plugin
export var outerContainer = "index-module--outerContainer--J3geM";
export var wrapper = "index-module--wrapper--1sSbr";